import { gql } from "@apollo/client";

// queries
export const BUYER_AVAILABILITY = gql`
	query AvailabilitySlotsV2($filters: BUQueryFilters) {
		buyerUnits(filters: $filters) {
			availabilitySlotsV2 {
				currentBuyerSlots {
					startTime
					endTime
				}
				otherBuyerSlots {
					startTime
					endTime
				}
				sellerSlots {
					startTime
					endTime
				}
			}
		}
	}
`;

export const SELLER_AVAILABILITY = gql`
	query VisitAvailabilitySlotsV2($filters: UnitQueryFilters) {
		units(filters: $filters) {
			visitAvailabilitySlotsV2 {
				currentSellerSlots {
					startTime
					endTime
				}
				otherSellerSlots {
					startTime
					endTime
				}
				buyerSlots {
					startTime
					endTime
				}
			}
		}
	}
`;

export const AVAILABILITY_VALIDATE_USER = gql`
	query BuyerUnits($filters: BUQueryFilters) {
		buyerUnits(filters: $filters) {
			availabilityValidateUser {
				isValidUser
				maskedUserContacts {
					phone
					email
				}
				lastUpdateInfo {
					lastUpdateBy
					lastUpdateAt
				}
				error
			}
		}
	}
`;

// mutations
export const SELLER_AVAILABILITY_MUTATION = gql`
	mutation Seller($params: SellerParams) {
		seller(params: $params) {
			sellerAvailabilityV2
		}
	}
`;

export const SELLER_GENERAL_AVAILABILITY_MUTATION = gql`
	mutation Seller($params: SellerParams) {
		seller(params: $params) {
			sellerGeneralAvailability
		}
	}
`;

export const SELLER_VERIFICATION_MUTATION = gql`
	mutation SellerVerification($params: SellerParams) {
		seller(params: $params) {
			sellerVerificationRequest
		}
	}
`;

export const SELLER_REQUEST_UNIT_UPDATE_MUTATION = gql`
	mutation Seller($params: SellerParams) {
		seller(params: $params) {
			requestUnitUpdate
		}
	}
`;

export const GET_UNIT_REQUEST = gql`
	query UnitRequestOne($filters: UnitQueryFilters) {
		units(filters: $filters) {
			unitRequestOne {
				_id
				info {
					unit {
						id
					}
				}
				status {
					open
				}
				createdAt
				updatedAt
				createdBy
				updatedBy
			}
		}
	}
`;
